__webpack_require__.p = "/react-global-state-hooks-example/";